import { DeepSafePartial } from 'types/types';
import { LocationModel } from './types';

/**
 * This checks for all the properties of the incoming data and looks for a
 * value. In the scenario a value is defined, we assume that this is being used.
 * However, there may be instances as the object may be fully built out and
 * checking "data !== undefined" would make it pass, thus, this would get passed
 * into "isInternational" and that would assume that the address is an
 * international address.
 */
export function isLocationModelDefined(data: DeepSafePartial<LocationModel> = {}) {
  let isDefined = false;

  Object.keys(data).forEach((key) => {
    if (data[key as keyof LocationModel] !== '' && data[key as keyof LocationModel] !== undefined) { isDefined = true; }
  });

  return isDefined;
}
